import React from 'react'

import Footer from './sections/Footer'
import Header from './sections/Header'
import Page from '../../../../components/pdf/Page'

import CoverSection from './sections/00.CoverSection'
import SumarioSection from './sections/00b.SumarioSection'
import ControleRevisoesSection from './sections/00c.ControleRevisoesSection'
import InformacoesIniciaisSection from './sections/01.InformacoesIniciaisSection'
import IntroducaoSection from './sections/02.IntroducaoSection'
import ObjetivoSection from './sections/03.ObjetivoSection'
import DireitosEDeveresSection from './sections/04.DireitosEDeveresSection'
import MetodologiaSection from './sections/05.MetodologiaSection'
import DescricaoAtividadesSection from './sections/06.DescricaoAtividadesSection'
import MetodologiaFisicoQuimicoErgonomicoSection from './sections/07.MetodologiaFisicoQuimicoErgonomicoSection'
import ClassificacaoDosRiscosSection from './sections/08.ClassificacaoDosRiscosSection'
import ClassificacaoRiscosFisicoQuimicoBiologicoSection from './sections/09.ClassificacaoRiscosFisicoQuimicoBiologicoSection'
import ClassificacaoRiscosErgonomicoPsicossocialSection from './sections/10.ClassificacaoRiscosErgonomicoPsicossocialSection'
import PlanoDeAcaoDefinicaoAplicabilidadeSection from './sections/11.PlanoDeAcaoDefinicaoAplicabilidadeSection'
import MonitoramentoExposicaoSection from './sections/12.MonitoramentoExposicaoSection'
import PlanoRespostaEmergenciasSection from './sections/14.PlanoRespostaEmergenciasSection'
import GestaoParticipativaCipaSection from './sections/15.GestaoParticipativaCipaSection'
import RegistroControleAvaliacaoRevisaoSection from './sections/16.RegistroControleAvaliacaoRevisaoSection'
import GestaoEmpresasTerceirasSection from './sections/17.GestaoEmpresasTerceirasSection'
import InventarioRiscosSection from './sections/18.InventarioRiscosSection'
import PlanoDeAcaoSection from './sections/19.PlanoDeAcaoSection'
import ConsideracoesFinaisSection from './sections/20.ConsideracoesFinaisSection'
import CertificadoCalibracaoSection from './sections/21.CertificadoCalibracaoSection'
import { BODY_ORIGIN_ID } from './_helpers/pagination'
import { getExecutorCertificadoCalibracao } from './_helpers/certificadoEngine'

/**
 * Documento PGR Bradesco. As seções institucionais (2-9, 10-17, 19 e 20) contêm o
 * texto literal do modelo aprovado por Julia Buzzo ("Modelo PGR 2026 - Banco
 * Bradesco_Varejo"). Os nomes de arquivo (prefixo 00-21) são o slot/posição no documento
 * E o número de seção exibido — ambos alinhados com o modelo real desde esta revisão.
 *
 * HISTÓRICO (corrigido nesta revisão — Julia reportou "o ponto 10 11 e 12 estão errado...
 * precisa seguir igual ao modelo"): até aqui, os arquivos com prefixo "10" e "11"
 * continham uma DUPLICATA das tabelas de Gradação de Probabilidade/Severidade que já
 * existem, corretas, como subseções 9.2/9.3 (ver
 * `09.ClassificacaoRiscosFisicoQuimicoBiologicoSection.js`) — sob os títulos incorretos
 * "10. GRADAÇÃO DE PROBABILIDADE" e "11. GRADAÇÃO DE SEVERIDADE", que não existem no
 * documento real. O arquivo "12" duplicava a Matriz de Risco da subseção 9.3. Como
 * consequência, as Seções 11 (Plano de Ação: Definição e Aplicabilidade) e 12
 * (Monitoramento da Exposição) do documento real — que já estavam com texto correto e
 * corretamente rotuladas `numero={11}`/`numero={12}` — tinham sido colocadas no arquivo
 * "13" por falta de slot livre, e a Seção 10 real (Classificação dos Riscos:
 * Ergonômico/Psicossociais e Biomecânicos) nunca tinha sido implementada.
 * Corrigido: `10.ClassificacaoRiscosErgonomicoPsicossocialSection.js` agora contém a
 * Seção 10 real (texto+tabelas do método ERGOCHECK, extraído do modelo); o conteúdo de
 * Plano de Ação/Macroprocessos e Monitoramento da Exposição foi movido do extinto arquivo
 * "13" para `11.PlanoDeAcaoDefinicaoAplicabilidadeSection.js` e
 * `12.MonitoramentoExposicaoSection.js`, respectivamente (o diagrama "Macroprocessos"
 * também foi refeito para bater com o modelo real, ver comentário daquele arquivo). As
 * Seções 15 (Registro e Controle) e 16 (Avaliação Contínua e Revisão) continuam agrupadas
 * no arquivo "16" (fora do escopo desta correção, ver o comentário daquele arquivo).
 * Seção 21 (Certificado de Calibração): corrigida nesta revisão para vir do Campo Adicional
 * "Certificado de Calibração" da CONTA do usuário que executou a atividade
 * (`serviceOrder.user`, via `ExecutorCertificadoLoader.js`/`getExecutorCertificadoCalibracao`),
 * NUNCA das respostas da própria atividade — pedido de Julia Buzzo (PM, 2026-08-27). Sem esse
 * Campo Adicional configurado na conta do executor, cai de volta no exemplo estático do modelo
 * aprovado usado antes desta revisão (ver `21.CertificadoCalibracaoSection.js`).
 *
 * Sumário (00b) e páginas paisagem (18 e 19): confirmados por Julia Buzzo como
 * necessários — ver `00b.SumarioSection.js` e `sections/_shared/Landscape.js`
 * respectivamente para o detalhe de cada um e suas limitações.
 *
 * Controle de Revisões (00c): página do modelo real (página 5, entre o Sumário e a Seção
 * 1) que uma versão anterior deste PR tinha identificado mas deixado de fora por estar
 * fora do escopo daquela tarefa — adicionada nesta revisão, ver `00c.ControleRevisoesSection.js`.
 *
 * Logo duplicado na capa (bug confirmado por Julia Buzzo): o `header` do `<Page>` é
 * implementado como `<thead style="display: table-header-group">` (ver
 * `components/pdf/Page.js`) — o motor de impressão do Chromium repete esse `<thead>` em
 * TODAS as páginas geradas a partir daquela `<table>`, incluindo a primeira. Como
 * `CoverSection` já traz seu próprio logo (o real, 130px, conferido pixel-a-pixel — ver
 * `00.CoverSection.js`), passar `header={<Header />}` (logo de 110px) ao `<Page>` fazia a
 * capa exibir os dois logos. Não basta simplesmente remover `header` do `<Page>`: o logo
 * do cabeçalho precisa continuar se repetindo em TODAS as páginas internas (2+).
 *
 * Fluxo contínuo entre seções (bug reportado por Julia Buzzo com screenshot: a página da
 * Seção "Controle de Revisões" — `00c` — trazia a tabela pequena no topo e ficava com um
 * espaço em branco enorme antes da próxima página começar; "não precisa ter esse espaço
 * nas páginas, precisa ser algo contínuo"). Causa raiz: toda seção do corpo (00b-17, 20 e
 * 21) envolvia seu conteúdo num `<View pageBreakAfter>` (=> CSS `page-break-after: always`),
 * forçando uma quebra de página fixa depois de CADA seção, independente de quanto conteúdo
 * ela realmente tinha — como a maioria das seções não enche uma página A4 sozinha (a
 * "Controle de Revisões" é só um exemplo, não o único caso; ver histórico do PR), isso
 * deixava espaço em branco no fim da página sempre que a seção seguinte era empurrada
 * para uma nova página que não precisava começar ali. Corrigido removendo esse
 * `pageBreakAfter` de todas as seções normais (retrato) — elas agora fluem juntas na
 * mesma `<table>`/`<td>` que já as continha (ver abaixo) e o navegador só quebra a página
 * onde o conteúdo de fato não cabe mais, sem espaço artificial. Mantido `pageBreakAfter`
 * apenas onde é estrutural, não cosmético:
 * - `CoverSection` (00): convenção de página de rosto, deve ficar isolada mesmo sendo
 *   curta — não é o bug reportado (Julia se referiu à página 3, não à capa).
 * - `InventarioRiscosSection` (18) e `PlanoDeAcaoSection` (19): página paisagem (ver
 *   `_shared/Landscape.js`) — a troca do `page` nomeado do CSS Paged Media já força uma
 *   quebra na entrada/saída da orientação paisagem por especificação, então essas duas
 *   seções (e as `View` por GHE/cargo aninhadas em `18`) foram deixadas como estavam,
 *   fora do escopo deste ajuste.
 * Nenhuma lógica de cálculo/dado foi alterada — troca é só do `View` de layout de cada
 * seção (ver cada arquivo em `sections/`).
 *
 * Números de página reais no Sumário (reverte parcialmente a remoção feita pelo PR #731):
 * o `<div id={BODY_ORIGIN_ID}>` logo abaixo é a origem (altura zero) usada por
 * `_helpers/pagination.js` para medir em que página cada âncora do documento cai — ver o
 * comentário completo daquele arquivo e de `sections/00b.SumarioSection.js` para o
 * mecanismo e suas limitações conhecidas.
 *
 * Como uma página impressa só pode ter um elemento com `id="pdfPage"` (é por esse id que
 * `printPdf.js`/`print-js`, compartilhado com outras marcas, localiza a árvore a
 * imprimir — ver `components/pdf/options/_helpers/printPdf.js`), não é possível resolver
 * isso com dois `<Page>` (dois `id="pdfPage"` faria o `print-js` imprimir só o primeiro e
 * descartar o resto do documento). A correção fica então só em `PdfDocument.js`: mantém
 * um único `<Page>` (sem `header`, só `footer`, que deve mesmo repetir desde a capa — ver
 * comentário em `00.CoverSection.js`) e aninha, DEPOIS da capa, uma segunda `<table>` só
 * com o seu próprio `<thead>` (`<Header />`) envolvendo as demais seções. Um `<thead
 * display: table-header-group">` de uma tabela aninhada só repete nas páginas que AQUELA
 * tabela (interna) ocupa — como ela só começa depois da capa (que fecha com
 * `pageBreakAfter` em `CoverSection`), o logo do cabeçalho passa a aparecer a partir da
 * página 2, nunca na capa. Confirmado renderizando o PDF real via Playwright/Chromium
 * (mesmo motor do `page.pdf()` usado pelo `print-js` em produção) — ver observação no PR.
 */
const PdfDocument = ({ serviceOrder, assets, executorFieldValues }) => {
  const certificadoExecutor = getExecutorCertificadoCalibracao(executorFieldValues)

  return (
    <Page footer={<Footer />}>
      <CoverSection serviceOrder={serviceOrder} />

      <table style={{ width: '100%' }}>
        <thead style={{ display: 'table-header-group' }}>
          <tr>
            <th>
              <Header />
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              {/* Marcador de altura zero usado como origem da medição de paginação real do
                  Sumário (ver `_helpers/pagination.js`) — precisa ficar bem no topo do fluxo
                  de conteúdo do corpo (logo depois do `<thead>` que se repete a partir da
                  página 2), antes de qualquer seção. */}
              <div id={BODY_ORIGIN_ID} style={{ height: 0, overflow: 'hidden' }} />
              <SumarioSection />
              <ControleRevisoesSection />
              <InformacoesIniciaisSection serviceOrder={serviceOrder} />
              <IntroducaoSection />
              <ObjetivoSection />
              <DireitosEDeveresSection />
              <MetodologiaSection serviceOrder={serviceOrder} assets={assets} />
              <DescricaoAtividadesSection serviceOrder={serviceOrder} assets={assets} />
              <MetodologiaFisicoQuimicoErgonomicoSection />
              <ClassificacaoDosRiscosSection />
              <ClassificacaoRiscosFisicoQuimicoBiologicoSection />
              <ClassificacaoRiscosErgonomicoPsicossocialSection />
              <PlanoDeAcaoDefinicaoAplicabilidadeSection />
              <MonitoramentoExposicaoSection />
              <PlanoRespostaEmergenciasSection />
              <GestaoParticipativaCipaSection />
              <RegistroControleAvaliacaoRevisaoSection />
              <GestaoEmpresasTerceirasSection />
              <InventarioRiscosSection serviceOrder={serviceOrder} assets={assets} />
              <PlanoDeAcaoSection />
              <ConsideracoesFinaisSection />
              <CertificadoCalibracaoSection certificadoExecutor={certificadoExecutor} />
            </td>
          </tr>
        </tbody>
      </table>
    </Page>
  )
}

export default PdfDocument
